import React from 'react';
import { Button } from 'antd';

const TeamPerformanceTitle = ({
  icon,
  title,
  showBtn = false,
  btnTitle,
  btnAction,
}: any) => (
  <div className="flex gap-2 items-center justify-between w-full">
    <div className="flex gap-2 items-center">
      {icon ? (
        <span
          className={`${title === 'Insights' ? 'bg-neutral-10' : 'bg-primary-50'} text-primary-500 pt-3 pb-sm px-3 rounded`}
        >
          {icon}
        </span>
      ) : null}
      <h4 className={`${icon ? 'text-md' : 'text-sm'} font-medium m-0`}>
        {title}
      </h4>
    </div>
    {showBtn ? (
      <Button onClick={btnAction} className="ml-auto" type="link">
        {btnTitle}
      </Button>
    ) : null}
  </div>
);

export default TeamPerformanceTitle;
